// extracted by mini-css-extract-plugin
export var brand = "_8m-9";
export var compact = "_8m-6";
export var extraSmall = "_8m-7";
export var icon = "_8m-0";
export var large = "_8m-4";
export var light = "_8m-1";
export var medium = "_8m-5";
export var outline = "_8m-b";
export var primaryDark = "_8m-a";
export var primaryLight = "_8m-8";
export var primaryModern = "_8m-c";
export var success = "_8m-2";
export var successSolid = "_8m-3";